/* components/ProductsFilters
- Used within collection and search templates

Example
<collection-filters>
    [[collection filters content]]
</collection-filters>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionFilters extends ThemeComponent {

    @Ref()
    form!: HTMLButtonElement;

    @Ref()
    details!: HTMLDetailsElement[];

    @Ref({required: false})
    triggers!: HTMLButtonElement[];

    @Ref()
    checkboxes!: HTMLInputElement[];

    private searchParamsInitial: string = window.location.search.slice(1);
    private searchParamsPrev: string = window.location.search.slice(1);
    private filterData: { html: string; url: string }[] = [];

    init() {
        this.setEventListeners();
    }

    private setEventListeners() {

        this.$listen(this.form, 'submit', (event) => {
            event.preventDefault();
            this.onSubmitHandler(event);
        });

        for (const detail of this.details) {
            this.$listen(detail, 'click', (event) => {
                event.stopPropagation();
                const thisElement = event.currentTarget as Element;

                const thisTarget = event.target as Element;

                const isLink = this.details.some(
                    (f) => f == event.target
                    || f == thisTarget?.parentElement
                    || f == thisTarget?.parentElement?.parentElement
                );

                if (isLink && thisElement.hasAttribute('open')) {

                    event.preventDefault();

                    thisElement.removeAttribute('open');

                    return;

                } else if (isLink) {
                    event.preventDefault();
                    const otherOpenDetails = document.querySelectorAll('details[open]');

                    if (!otherOpenDetails) {return;}

                    for (const otherOpenDetail of otherOpenDetails) {
                        otherOpenDetail.removeAttribute('open');
                    }

                    const thisDetails = thisTarget.closest('details');

                    if (!thisDetails) {return;}

                    thisDetails.setAttribute('open', '');

                } else if (!isLink) {
                    return;
                }

            });
        }
    }

    private getSections() {
        const gridElement = document.getElementById('product-grid');
        if (!gridElement) {return;}
        return [
            {
                section: gridElement.dataset.id,
            }
        ];
    }

    private updateURLHash(searchParams: string) {
        const pathname = window.location.pathname;
        history.pushState({ searchParams }, '', `${pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    public onSubmitHandler(event: Event) {

        const target = event.target as HTMLFormElement;

        const searchParams = this.createSearchParams(target);

        this.renderPage(searchParams, event);
    }

    private toggleActiveFacets(disable: boolean = true) {
        const elements = document.querySelectorAll('.js-facet-remove') as NodeListOf<HTMLDivElement>;

    }

    private createSearchParams(form: HTMLFormElement) {
        const convertedFormEntries = Array.from(
            new FormData(form),
            ([key, value]) => (
                [key, typeof value === 'string' ? value : value.name]
            ),
        );
        return new URLSearchParams(convertedFormEntries).toString();
    }

    private renderSectionFromFetch(url: string, event: Event) {

        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;

                this.filterData = [...this.filterData, { html, url }];

                this.renderProductGridContainer(html);

                this.renderActiveFacets(html);
            }).catch((err) => {
                debugger; // eslint-disable-line no-debugger
            });
    }

    private renderProductGridContainer(html: string) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const productGridContainer = document.getElementById('ProductGridContainer');
        if (!productGridContainer) {return;}
        const parsedProductGridContainer = parsedHTML.getElementById('ProductGridContainer');
        if (!parsedProductGridContainer) {return;}
        productGridContainer.innerHTML = parsedProductGridContainer.innerHTML;
    }

    private renderFilters(html: string, event: Event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElements =
          parsedHTML.querySelectorAll('#collectionFiltersForm .js-filter');

        const target = event.target as HTMLDivElement;

        const matchesIndex = (element: HTMLDivElement) => {

            const jsFilter = target as HTMLDivElement;

            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };

        const facetsToRender = Array.from(facetDetailsElements).filter((element) => {
            const newElement = element as HTMLDivElement;
            return !matchesIndex(newElement);
        });

    }

    private renderActiveFacets(html: string) {

        this.toggleActiveFacets(false);
    }

    private renderPage(searchParams: string, event: Event, updateURLHash: boolean = true) {
        this.searchParamsPrev = searchParams;

        const sections = this.getSections();
        const gridContainer = document.getElementById('ProductGridContainer');

        if (gridContainer) {
            const collectionContainer = gridContainer.querySelector('.collection');
            if (collectionContainer) {
                collectionContainer.classList.add('loading');
            }
        }

        if (!sections) {return;}

        const url = `${window.location.pathname}?section_id=${sections[0].section}&${searchParams}`;

        if(!url) {return;}

        this.renderSectionFromFetch(url, event);

        if (updateURLHash) {
            this.updateURLHash(searchParams);
        }

    }
}
